// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ndiv.user>div>div>.agent-icon-img {\r\n  display: none;\n}\n.agent-icon-img {\r\n  position: inherit;\r\n  height: 100%;\r\n  background-color: white;\r\n  border-radius: 50%;\r\n  z-index: 0;\r\n  width: 100%;\r\n  -o-object-fit: cover;\r\n     object-fit: cover;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
